function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form as FormikForm } from 'formik';

const Form = ({
  children,
  FormProps,
  initialValues,
  validationSchema,
  ...props
}) => {
  const coercedInitialValuesEntries = Object.entries(initialValues).map(([key, value]) => [key, value === null ? undefined : value]);
  initialValues = Object.fromEntries(coercedInitialValuesEntries);
  return React.createElement(Formik, _extends({
    initialValues: { ...validationSchema.cast(),
      ...initialValues
    } // this is needed to get validation to work properly
    ,
    validationSchema: validationSchema
  }, props), formikProps => React.createElement(FormikForm, FormProps, children(formikProps)));
};

Form.propTypes = {
  FormProps: PropTypes.object,
  initialValues: PropTypes.object,
  validationSchema: PropTypes.object.isRequired
};
Form.defaultProps = {
  FormProps: {},
  initialValues: {}
};
export default Form;